import { Mapper } from "../../../../base/utils/mapper";
import { ProcedureNonSurgicalModel } from "../../../../domain/models/consult/procedure-non-surgical.model";
import { ProcedureNonSurgicalEntity } from "../entities/procedure-non-surgical.entity";

export class ProcedureNonSurgicalImplementationRepositoryMapper extends Mapper<ProcedureNonSurgicalEntity, ProcedureNonSurgicalModel> {
    mapFrom(param: ProcedureNonSurgicalEntity): ProcedureNonSurgicalModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProcedureNonSurgicalModel): ProcedureNonSurgicalEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}